import React from 'react';

const ProgressBar = (props) =>
{
  return (
   <div className = "progress-bar-element" >
          <Filler percentage={props.percentage} />
   </div>
  )
}

const Filler = (props) => {
  //  alert("Filler percentage: " + props.percentage);
    let filler_percentage = props.percentage;
    return <div className="filler" style={{ width: `${filler_percentage}%` }} />
}

export default ProgressBar;